import React, { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const TwQuillEditor = ({ value = "", onChange, placeholder = "Start typing..." }) => {
  const editorRef = useRef(null);
  const quillInstance = useRef(null);
  const isSettingContent = useRef(false);

  useEffect(() => {
    if (editorRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(editorRef.current, {
        theme: "snow",
        placeholder,  // <-- here!
        modules: {
          toolbar: [
            [{ font: [] }, { size: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            // [{ script: "sub" }, { script: "super" }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            // [{ direction: "rtl" }],
            [{ align: [] }],
            // ["blockquote", "code-block"],
            [
              "link",
              // "image", 
              // "video", 
              // "formula"
            ],
            // ["clean"],
          ],
        },
      });

      quillInstance.current.on("text-change", () => {
        if (isSettingContent.current) return;
        const html = quillInstance.current.root.innerHTML;
        onChange?.(html);
      });

      quillInstance.current.root.innerHTML = value;
    }
  }, []);

  useEffect(() => {
    if (
      quillInstance.current &&
      quillInstance.current.root.innerHTML !== value
    ) {
      isSettingContent.current = true;
      quillInstance.current.root.innerHTML = value;
      isSettingContent.current = false;
    }
  }, [value]);

  return (
    <div className="rounded-md">
      {/* Toolbar and editor container */}
      <div className="h-64 min-h-[120px]" ref={editorRef} />
    </div>
  );
};

export default TwQuillEditor;